import { isFunction } from "lodash"

import { AnyValue } from "../types/AnyValue"

export default async function getAnyValue<T, U>(value: AnyValue<T, U>, ...fnArgs: U[]): Promise<T> {
  if (isFunction(value)) {
    const res = value(...fnArgs)

    if (res instanceof Promise) {
      return await res
    } else {
      return res
    }
  }

  return value
}
